module.exports = __webpack_public_path__ + "img/Insurance-cost.eff97cb7.svg";